import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../shared/api.service';
import { PollItemData } from '../../../models/PollItemData';
import { PollDashboardResponse } from '../../../models/PollDashBoardResponse';
import { AuthenticationService } from '../../../shared/authentication.service';
import { LicenseService } from '../../../shared/licens.service';
import { SubsciptionData, LicenseData } from '../../../models/LicenseData';
import { Common } from '../../../shared/common';
import {  EmployerContact } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-employer',
  templateUrl: 'pap-employer.component.html',
  styleUrls: ['./pap-employer.component.less', '../../../shared/common.less'],
})

export class PapEmployerComponent implements OnInit {
  @Input() employer: EmployerContact;
  @Output() employerChange = new EventEmitter<EmployerContact>();

  needPap: boolean = undefined;

  constructor(
    private router: Router,
  ) {}
  
  onEmployerChange() {
    this.employerChange.emit(this.employer);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }
  
  ngOnInit(): void {
  }
}
